const POPPER_OFFSET_X = -16;
const POPPER_OFFSET_Y = -4;

export const defaultPopoverOptions = {
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'center',
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'center',
  },
};

export const PopperPlacementType = {
  TOP: 'top',
  TOP_START: 'top-start',
  TOP_END: 'top-end',
  BOTTOM: 'bottom',
  BOTTOM_START: 'bottom-start',
  BOTTOM_END: 'bottom-end',
  LEFT: 'left',
  LEFT_START: 'left-start',
  LEFT_END: 'left-end',
  RIGHT: 'right',
  RIGHT_START: 'right-start',
  RIGHT_END: 'right-end',
};

export const PopoverReference = {
  ANCHOR_ELEMENT: 'anchorEl',
  ANCHOR_POSITION: 'anchorPosition',
};

export const PopperOffset = {
  [PopperPlacementType.TOP_START]: [POPPER_OFFSET_X, POPPER_OFFSET_Y],
};
